import React, { Component } from "react";
import { connect } from "react-redux";
import { createTutorial } from "../actions/tutorials";

// again yuck to class based components....
// ultimately this component is just rendering a form for 3 fields and a button
// there is additional state but we do not have users input that data, its toggled later
class AddTutorial extends Component {
  constructor(props) {
    super(props);
    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeDescription = this.onChangeDescription.bind(this);
    this.onChangeAuthor = this.onChangeAuthor.bind(this);
    this.saveTutorial = this.saveTutorial.bind(this);
    this.newTutorial = this.newTutorial.bind(this);

    this.state = {
      id: null,
      title: "",
      description: "",
      author: "",
      published: false,
      submitted: false,
    };
  }

  // again, notice a refactoring opportunity, 3 methods very similar
  onChangeTitle(e) {
    this.setState({
      title: e.target.value,
    });
  }
  onChangeDescription(e) {
    this.setState({
      description: e.target.value,
    });
  }
  onChangeAuthor(e) {
    this.setState({
      author: e.target.value,
    });
  }

  // saving a tutorial requires the 3 fields for creation
  // then we attempt to set state for the new tutorial
  // why? this is effectively our submit method
  saveTutorial() {
    const { title, description, author } = this.state;
    this.props
      .createTutorial(title, description, author)
      .then((data) => {
        this.setState({
          id: data.id,
          title: data.title,
          description: data.description,
          author: data.author,
          published: data.published,
          submitted: true,
        });
        console.log(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // again pretty sure this can be refactored bc identical to the initial state above
  newTutorial() {
    this.setState({
      id: null,
      title: "",
      description: "",
      author: "",
      published: false,
      submitted: false,
    });
  }

  // render method returns a message on success, and a "form" when not yet successful
  // we conditionally render either the message or the "form"
  // it uses onChange to update the state as we type, but submit is still required eventually
  // if we change the div to a form then we need to add e.preventDefault()
  render() {
    return (
      <div className="submit-form">
        {this.state.submitted ? (
          <div>
            <h4>You submitted successfully!</h4>
            <button className="btn btn-success" onClick={this.newTutorial}>
              Add
            </button>
          </div>
        ) : (
          <div>
            <div className="form-group">
              <label htmlFor="title">Title</label>
              <input
                type="text"
                className="form-control"
                id="title"
                required
                value={this.state.title}
                onChange={this.onChangeTitle}
                name="title"
              />
            </div>
            <div className="form-group">
              <label htmlFor="description">Description</label>
              <input
                type="text"
                className="form-control"
                id="description"
                required
                value={this.state.description}
                onChange={this.onChangeDescription}
                name="description"
              />
            </div>
            {/* TODO:
              0. only add if author name matches one of the existing author names in backend /authors
              1. make this field invisible
              2. replace this field with authenticated user name
            */}
            {/* <div className="form-group poof"> */}
            <div className="form-group">
              <label htmlFor="author">Author</label>
              <input
                type="text"
                className="form-control"
                id="author"
                required
                value={this.state.author}
                onChange={this.onChangeAuthor}
                name="author"
              />
            </div>
            <button onClick={this.saveTutorial} className="btn btn-success">
              Submit
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default connect(null, { createTutorial })(AddTutorial);
